import React from "react";
import { motion } from "framer-motion";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1551135049-8a33b5883817?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGNvbnN1bHRpbmclMjBvZmZpY2V8ZW58MHx8fHwxNzc5MjMyMzczfDA&ixlib=rb-4.1.0&q=85";

export const AboutUs = () => {
  return (
    <section
      id="quienes-somos"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="container-page">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5 order-2 lg:order-1"
          >
            <div className="relative">
              <div className="absolute -inset-6 bg-[#72B3E4]/15 rounded-3xl rotate-2" />
              <div className="absolute -inset-4 bg-[#055794]/10 rounded-3xl -rotate-1" />
              <img
                src={ABOUT_IMG}
                alt="Equipo de Comisión Empresarial colaborando"
                className="relative rounded-3xl w-full object-cover h-[420px] lg:h-[520px] shadow-[0_30px_60px_-20px_rgba(2,33,64,0.3)]"
                data-testid="about-image"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#022140] text-white px-6 py-5 rounded-2xl shadow-xl hidden md:block">
                <p className="font-heading text-3xl font-bold">100%</p>
                <p className="text-xs uppercase tracking-[0.2em] text-[#72B3E4]">
                  Soluciones personalizadas
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-7 order-1 lg:order-2"
          >
            <p className="text-xs uppercase tracking-[0.25em] text-[#055794] font-semibold mb-5">
              Descripción de la empresa
            </p>
            <h2
              data-testid="about-title"
              className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#022140] tracking-tight leading-[1.05]"
            >
              ¿Quiénes somos?
            </h2>
            <div className="mt-8 space-y-6 text-[17px] text-[#022140]/80 leading-relaxed">
              <p data-testid="about-paragraph">
                En Comisión Empresarial para el Desarrollo Profesional, somos
                una organización privada dedicada a impulsar la competitividad
                de México mediante la inclusión laboral y la investigación
                social aplicada. Nos especializamos en diseñar programas de
                orientación social y capacitación para el trabajo, enfocados
                específicamente en dotar de competencias técnicas a personas
                desempleadas, subempleadas o con discapacidad. Al transformar
                la vulnerabilidad en productividad, ayudamos a las empresas a
                cumplir sus metas de sustentabilidad mientras abrimos
                oportunidades reales en el mercado.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-6 max-w-md">
              <div className="border-l-2 border-[#055794] pl-4">
                <p className="font-heading text-3xl font-bold text-[#022140]">
                  Nacional
                </p>
                <p className="text-sm text-[#7F7F7F] mt-1">
                  e Internacional
                </p>
              </div>
              <div className="border-l-2 border-[#72B3E4] pl-4">
                <p className="font-heading text-3xl font-bold text-[#022140]">
                  Líderes
                </p>
                <p className="text-sm text-[#7F7F7F] mt-1">
                  en competitividad
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
